import Vue from 'vue';
import { mediaUrl } from '@/config';

const FullBackgroundImagePath = {
    async bind(el, binding) {
        const { value, arg, modifiers } = binding;

        if (!value) {
            return null;
        }

        if (arg === 'assets') {
            let src = value;

            if (modifiers['load-webp'] && checkIfWebSupported()) {
                const [name] = src.split('.');

                src = `${name}.webp`;
            }

            el.style.backgroundImage = `url(${require(`@/assets/images/${src}`)})`;

            return;
        }

        function createBackgroundImage() {
            if (!value.id) {
                const url = require(arg === 'avatar'
                    ? '@/assets/images/user.jpg'
                    : '@/assets/images/no-image.png');

                el.style.backgroundImage = `url(${url})`;

                return;
            }

            const {
                date,
                extension,
                meta: { breakpoints },
                filename
            } = value;

            const isWebSupported = checkIfWebSupported();

            const selectedBreakPoint = findBreakPointToUse(
                breakpoints,
                el.offsetWidth
            );

            const url = `${mediaUrl}/images/${date}/${filename}${
                selectedBreakPoint ? `_${selectedBreakPoint}` : ''
            }.${isWebSupported && extension !== 'svg' ? 'webp' : extension}`;

            el.style.backgroundImage = `url(${url})`;
        }

        function handleIntersectForApi(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    createBackgroundImage();
                    observer.unobserve(el);
                }
            });
        }

        function createObserver(handler) {
            const options = {
                root: null,
                threshold: '0'
            };

            const observer = new IntersectionObserver(handler, options);
            observer.observe(el);
        }

        if (window.IntersectionObserver) {
            createObserver(handleIntersectForApi);

            return;
        }

        createBackgroundImage();
    }
};

Vue.directive('full-background-image-path', FullBackgroundImagePath);

function findBreakPointToUse(breakpoints, width) {
    if (!breakpoints || !breakpoints.length) {
        return null;
    }

    let breakPointsCopy = [...breakpoints];
    breakPointsCopy.sort((a, b) => b - a);

    if (breakPointsCopy[0] < width) {
        return null;
    }

    return breakPointsCopy.find((breakpoint, breakpointIndex) => {
        const nextBreakpoint = breakPointsCopy[breakpointIndex + 1];

        return (
            (breakpoint < width && nextBreakpoint < width) ||
            (breakpoint >= width &&
                (nextBreakpoint ? nextBreakpoint < width : true))
        );
    });
}

function checkIfWebSupported() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    return !isSafari;
}
